import React from "react";
import { FiPower } from "react-icons/fi";
import { FaUser } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useGlobalContext } from "../../hooks/context";
import UserAccess from "../../components/404/UserAccess";
import NotFound from "../../components/404";
import ClientInfo from "./ClientInfo";
import Pairing from "./Pairing";

const {
  REACT_APP_LOGIN_PAYMENT_EMAIL: paymentEmail,
  REACT_APP_LOGIN_AUTHOR_EMAIL: authorEmail,
} = process.env;

const TestPair = () => {
  const { user, userLogout } = useGlobalContext();
  const { isLoggedIn, email } = user || {};

  if (isLoggedIn && email === authorEmail) {
    return <UserAccess />;
  }
  if (isLoggedIn && email !== paymentEmail) {
    return <NotFound />;
  }

  return (
    <div className="pl-16 pr-20 py-20">
      <div className="flex justify-between items-center">
        <Link to="/">
          <img
            src="/logo/donation-logo.png"
            alt="fund_a_chairty"
            className="w-48 h-24"
          />
        </Link>
        <img src="/logo/pair-logo.png" alt="pairing" className="w-24 h-24" />
      </div>
      <div className="px-10">
        <div className="mt-10 flex justify-between items-center">
          <div>
            <h1 className="text-3xl text-custom-gray-800">
              <strong>WELCOME</strong> TO
            </h1>
            <h2 className="text-2xl text-custom-gray-800">
              PAYMENT PARING SETTINGS:{" "}
            </h2>
          </div>
          <div className="flex items-center gap-x-5">
            <button onClick={userLogout}>
              <FiPower size={28} />
            </button>
            <div className="w-[1px] h-5 border-r-2 border-gray-500" />
            <span className="p-1.5  bg-gray-400 rounded-full">
              <FaUser size={20} />
            </span>
          </div>
        </div>
        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2">
          <Pairing />
          <ClientInfo />
        </div>
      </div>
    </div>
  );
};

export default TestPair;
